import { render, staticRenderFns } from "./LinePayFail.vue?vue&type=template&id=89350538&"
import script from "./LinePayFail.vue?vue&type=script&lang=js&"
export * from "./LinePayFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LinePayFail.vue"
export default component.exports